import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { faqs } from "./components/FAQ";
import Navbar from "@/components/feature/Navbar";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "@/components/feature/Footer";
import FloatingButton from "@/components/feature/FloatingButton";
import Avis from "@/components/feature/Avis";
import Hero from "./components/Hero";
import Reassurances from "./components/Reassurances";
import Pourquoi from "./components/Pourquoi";
import CommentCaSePasse from "./components/CommentCaSePasse";
import Commandes from "./components/Commandes";
import VoletExistant from "./components/VoletExistant";
import CTAAppel from "./components/CTAAppel";
import FAQ from "./components/FAQ";
import Galerie from "./components/Galerie";
import Maillage from "./components/Maillage";
import Formulaire from "./components/Formulaire";

export default function MotorisationSomfyPage() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Motorisation Volet Roulant Strasbourg | Somfy Dépan'Volets"
        description="Motorisation de volet roulant avec moteur Somfy à Strasbourg et dans le Bas-Rhin. Transformation manuel vers électrique, devis gratuit. 03 74 47 32 40."
        path="/motorisation-somfy"
        type="service"
        serviceType="Motorisation de volet roulant"
        faqs={faqs}
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Motorisation" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Motorisation" }]} />
      <main>
        <Hero />
        <DiagnosticVideo />
        <Reassurances />
        <Pourquoi />
        <CommentCaSePasse />
        <Commandes />
        <VoletExistant />
        <CTAAppel />
        <FAQ />
        <Galerie />
        <Maillage />
        <Formulaire />
        <Avis />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}